import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	register: Function
	errors: any
	watch: Function
	setValue: Function
}
const MafoQuestionSix: React.FC<MafoQuestionProps> = ({ register, errors, watch, setValue }) => {
	const questionSixValue = watch("question6")
	const hasOtherOptionSelected = Array.isArray(questionSixValue) ? questionSixValue.includes("k") : questionSixValue === "k"

	React.useEffect(() => {
		if (!hasOtherOptionSelected) {
			setValue("question6Other", "")
		}
	}, [hasOtherOptionSelected, setValue])
	return (
		<>
			<h3 className="mafo-headline text-left text-blue">6. Welches Kriterium ist für Dich das wichtigste?</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>Hoher Proteingehalt</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="a" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Vegan / pflanzlich</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="b" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Wenig Zucker / zuckerreduziert</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="c" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Guter Geschmack</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="d" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Gutes Preis-Leistungs-Verhältnis</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="e" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Hoher Ballaststoffgehalt</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="f" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Natürliche Zutaten</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="g" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Gerade im Angebot/ Werbung im Geschäft</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="h" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Empfehlung von Freunden oder Influencern</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="i" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Nachhaltigkeit</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="j" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Sonstiges</>} className=" pb-2 text-green">
					<input type="radio" {...register("question6")} name="question6" value="k" className={"peer absolute hidden h-1 w-1 " + (errors.question6 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				{hasOtherOptionSelected && (
					<>
						<textarea {...register("question6Other")} name="question6Other" maxLength={99} className="h-[150px] w-full bg-[#F7F7F7] py-4 px-2 border-blue border-[1px]"></textarea>
					</>
				)}
			</div>
		</>
	)
}

export default MafoQuestionSix
